import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNotFound = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 96,
	height: 96,
	viewBox: "0 0 96 96",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M19 51C19 73.5 43 89.5 43 89.5C43 89.5 29 58 26.5 47.5C24 37 22 20 22 20L19 51Z",
			fill: "#6C6DCE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M48.7841 88.2708L68.278 95.913C68.4247 95.9705 68.5809 96 68.7384 96C69.4352 96 70 95.4352 70 94.7384V3.67199C70 3.28258 69.9114 2.89828 69.7409 2.54817L69.6909 2.44559C69.0532 1.13588 67.4243 0.662665 66.184 1.42673C66.0616 1.50217 65.946 1.58819 65.8385 1.6838L64.3863 2.97607C60.5577 6.38284 55.7605 8.5454 50.6366 8.63989C41.4493 8.80931 30.6653 8.2139 28 8.2139C25.2954 8.2139 19.9036 3.30898 17.5927 1.07973C16.9853 0.49381 16.0143 0.498726 15.4254 1.10329C15.1527 1.38337 15 1.75889 15 2.14987V13.3476V43.6364C15 43.8018 15.0003 43.9651 15.0009 44.1261C15.0289 51.8828 18.5321 59.7619 22.1864 66.6039C24.0447 70.083 26.5571 73.1706 29.5859 75.6973L34.5798 79.8634C38.8321 83.4108 43.6284 86.2496 48.7841 88.2708Z",
			fill: "#A8AAE3"
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "mask0_943_17761",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 15,
			y: 0,
			width: 55,
			height: 96,
			children: /* @__PURE__ */ _jsx("path", {
				d: "M48.7841 88.2708L68.278 95.913C68.4247 95.9705 68.5809 96 68.7384 96C69.4352 96 70 95.4352 70 94.7384V3.67199C70 3.28258 69.9114 2.89828 69.7409 2.54817L69.6909 2.44559C69.0532 1.13588 67.4243 0.662665 66.184 1.42673C66.0616 1.50217 65.946 1.58819 65.8385 1.6838L64.3863 2.97607C60.5577 6.38284 55.7605 8.5454 50.6366 8.63989C41.4493 8.80931 30.6653 8.2139 28 8.2139C25.2954 8.2139 19.9036 3.30898 17.5927 1.07973C16.9853 0.49381 16.0143 0.498726 15.4254 1.10329C15.1527 1.38337 15 1.75889 15 2.14987V13.3476V43.6364C15 43.8018 15.0003 43.9651 15.0009 44.1261C15.0289 51.8828 18.5321 59.7619 22.1864 66.6039C24.0447 70.083 26.5571 73.1706 29.5859 75.6973L34.5798 79.8634C38.8321 83.4108 43.6284 86.2496 48.7841 88.2708Z",
				fill: "#A8AAE3"
			})
		}),
		/* @__PURE__ */ _jsxs("g", {
			mask: "url(#mask0_943_17761)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M34 53V53C34.8794 51.0212 37.5822 50.7603 38.824 52.5342L39.5 53.5",
					stroke: "#6C6DCE",
					strokeWidth: .3,
					strokeLinecap: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M39 49.5V49.5C39.8794 47.5212 42.5822 47.2603 43.824 49.0342L44.5 50",
					stroke: "#6C6DCE",
					strokeWidth: .3,
					strokeLinecap: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M29 48.5V48.5C29.8794 46.5212 32.5822 46.2603 33.824 48.0342L34.5 49",
					stroke: "#6C6DCE",
					strokeWidth: .3,
					strokeLinecap: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M46 52.5V52.5C46.8794 50.5212 49.5822 50.2603 50.824 52.0342L51.5 53",
					stroke: "#6C6DCE",
					strokeWidth: .3,
					strokeLinecap: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M41 57.5V57.5C41.8794 55.5212 44.5822 55.2603 45.824 57.0342L46.5 58",
					stroke: "#6C6DCE",
					strokeWidth: .3,
					strokeLinecap: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M46 47.5V47.5C46.8794 45.5212 49.5822 45.2603 50.824 47.0342L51.5 48",
					stroke: "#6C6DCE",
					strokeWidth: .3,
					strokeLinecap: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M62 51.5C62 74 71.5 99.5 71.5 99.5V23.5V19C68.4342 25.1316 62.1404 40.5539 62.0308 47.4084C62.0107 48.6641 62 50.0251 62 51.5Z",
					fill: "#8588D8"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M68 75.5C68 98 73.5 108.5 73.5 108.5V32.5C73.5 31.9149 72.7221 31.8301 72.6125 32.4049C71.0566 40.5637 68 58.7265 68 75.5Z",
					fill: "#321F8D"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M15 53.5C15 76 36 89.5 36 89.5C36 89.5 22 58 19.5 47.5C17 37 15 20 15 20V53.5Z",
					fill: "#8588D8"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M30.5 76.5C30.5 76.5 13 76 13 53.5L14.7454 28.6287C14.6347 25.6088 15 25 15 25L14.7454 28.6287C14.8589 31.7287 15.4739 37.3693 17.5 47.5C21.5 67.5 30.5 76.5 30.5 76.5Z",
					fill: "#4F49BA"
				})
			]
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 32,
			cy: 26,
			r: 8,
			fill: "white",
			fillOpacity: .94
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 52,
			cy: 26,
			r: 8,
			fill: "white",
			fillOpacity: .94
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M42 34L45 37L42 40L39 37L42 34Z",
			fill: "#3F34A2"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 30,
			cy: 26,
			r: 3,
			fill: "black",
			fillOpacity: .94
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 50,
			cy: 26,
			r: 3,
			fill: "black",
			fillOpacity: .94
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M0 69C0 69 19.5 66 40 66C60.5 66 96 69 96 69V70C96 70 55.5 67 40 67C24.5 67 0 70 0 70V69Z",
			fill: "#4F49BA"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 33.5923,
			y: 63.1719,
			width: 2,
			height: 6,
			rx: 1,
			transform: "rotate(-8 33.5923 63.1719)",
			fill: "#321F8D"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 50,
			y: 63.2773,
			width: 2,
			height: 6,
			rx: 1,
			transform: "rotate(-8 50 63.2773)",
			fill: "#321F8D"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 35.5,
			y: 63.3477,
			width: 2,
			height: 4.63157,
			rx: 1,
			transform: "rotate(-11 35.5 63.3477)",
			fill: "#3F34A2"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 51.9077,
			y: 63.4531,
			width: 2,
			height: 4.63157,
			rx: 1,
			transform: "rotate(-11 51.9077 63.4531)",
			fill: "#3F34A2"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 37.5,
			y: 63.207,
			width: 2,
			height: 6,
			rx: 1,
			transform: "rotate(-5 37.5 63.207)",
			fill: "#321F8D"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 53.9077,
			y: 63.3125,
			width: 2,
			height: 6,
			rx: 1,
			transform: "rotate(-5 53.9077 63.3125)",
			fill: "#321F8D"
		})
	]
});
export default SvgNotFound;
